exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".courses a:active {\n  padding: 0 !important; }\n\n.tab-wrapper .nav-tabs-simple .active-bar {\n  height: 3px;\n  background-color: #586ff3;\n  bottom: 3px; }\n\n.status-check-tabs {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: transparent; }\n\n.status-check-tabs li {\n    float: left; }\n\n.status-check-tabs li a {\n      display: block;\n      color: #9B9B9B;\n      text-align: center;\n      padding: 14px 16px;\n      text-decoration: none;\n      font-weight: 700; }\n\n.status-check-tabs li a:hover:not(.active) {\n        color: #000; }\n\n.status-check-tabs li a.active {\n        border-bottom: 3px solid #2B61C3;\n        color: #2B61C3 !important; }\n\n.status-check-tabs-content {\n  background: #fff;\n  min-height: calc(100vh - 127px);\n  margin-bottom: 50px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user.component.scss
// module id = ../../../../../src/app/user-module/user.component.scss
// module chunks = main